import type { ConnectorCapability, ConnectorStatus } from '@/types'

export function connectorCapabilityFallback(): ConnectorCapability {
  return {
    implemented: false,
    configured: false,
    connected: false,
  }
}

export function isConnectorConnectable(capability: ConnectorCapability | undefined): boolean {
  if (capability?.availability) {
    return Boolean(capability.availability.implemented && capability.availability.configured)
  }
  return Boolean(capability?.implemented && capability?.configured)
}

export function isConnectorReady(
  capability: ConnectorCapability | undefined,
  status?: ConnectorStatus | string,
): boolean {
  if (capability?.availability?.contract_version === 'tool-availability/v1') {
    return Boolean(capability.availability.available)
  }
  if (!isConnectorConnectable(capability)) return false
  const authState = String(capability?.auth_state ?? 'ready')
  if (authState === 'missing' || authState === 'error') return false
  return Boolean(capability?.connected || status === 'connected')
}

export function getConnectorCapability(
  id: string,
  capabilities: Record<string, ConnectorCapability>,
): ConnectorCapability {
  return capabilities[id] ?? connectorCapabilityFallback()
}

export function filterReadyConnectorIds(
  connectorIds: string[] | null | undefined,
  capabilities: Record<string, ConnectorCapability>,
  statuses: Record<string, ConnectorStatus | string> = {},
  disabled: Record<string, boolean> = {},
): string[] {
  const ready: string[] = []
  const seen = new Set<string>()

  for (const id of connectorIds ?? []) {
    if (seen.has(id) || disabled[id]) continue
    seen.add(id)
    if (isConnectorReady(getConnectorCapability(id, capabilities), statuses[id])) {
      ready.push(id)
    }
  }

  return ready
}
